module.exports = __webpack_public_path__ + "img/DOCSGI.a1b11ce5.jpg";